import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'v4-selectable-menu-item',
  templateUrl: './selectable-menu-item.component.html',
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
    `,
  ],
})
export class V4SelectableMenuItemComponent implements OnInit {
  @Input() checked = false;
  constructor() {}

  ngOnInit() {}
}
